import { find, get } from "lodash";
import { MDBAnimation, MDBCol, MDBContainer, MDBRow, MDBView } from "mdbreact";
import React, { Component } from "react";
import Loadable from "react-loadable";
import { connect } from "react-redux";
import bgContact from "~/assets/img/desktop/common/blur-02.jpg";
import TagName from "~/components/common/atoms/TagName";
import { SEO } from "~/components/common/molecules/SEO";
import LoadableLoading from "~/components/mobile/molecules/LoadingPage";
import { partnerInfo } from "~/configs/partnerDetails";
import styles from "./style.module.scss";
const info = get(partnerInfo, "info");
const hospitalName = find(info, { key: "name" });

const HuongDanGeneral = Loadable({
  loader: () => import("~/detect_devices/HuongDanGeneral"),
  loading: LoadableLoading
});

class HuongDan extends Component {
  render() {
    const info = get(partnerInfo, "menu");
    const procedureInfo = find(info, { key: "quy-trinh" });
    return (
      <React.Fragment>
        <SEO
          title={`Hướng Dẫn | ${hospitalName.value}`}
          meta={[
            {
              name: `description`,
              content: `Medpro, đặt khám trực tuyến, thanh toán viện phí, nhắc uống thuốc, khám chuyên khoa, bác sĩ, tư vấn sức khoẻ từ xa`
            },
            {
              property: `og:title`,
              content: "Hướng Dẫn"
            },
            {
              property: `og:description`,
              content: `Trang Hướng Dẫn`
            },
            {
              property: `og:url`,
              content: "https://medpro.vn/quy-trinh"
            },
            {
              property: `og:image`,
              content: "https://cms.medpro.com.vn/uploads/d_e1b14f67d2.jpg"
            },
            {
              property: `og:type`,
              content: `website`
            }
          ]}
        />
        <MDBAnimation type="fadeIn">
          <div className="d-none d-lg-block">
            <MDBView className={styles.img_parallax} src={bgContact} fixed>
              <MDBContainer>
                <MDBRow>
                  <MDBCol>
                    <TagName
                      element="h1"
                      className={[
                        "title_component",
                        "title_line",
                        "title_contact"
                      ]}
                    >
                      <span>Hướng dẫn</span>
                    </TagName>
                  </MDBCol>
                </MDBRow>
              </MDBContainer>
            </MDBView>
          </div>
          <HuongDanGeneral procedureInfo={procedureInfo} />
        </MDBAnimation>
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => {
  const {
    global: {
      device: { type }
    }
  } = state;
  return {
    device: type
  };
};

export default connect(mapStateToProps)(HuongDan);
